import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

import { browserUtils } from "../../utils";
import { routeNames } from "../../routes";
import placeLogo from "../../assets/logos/PLACE_circlelogowithoutbuildings.png";
import goaaLogo from "../../assets/logos/Gulf-of-America-Alliance-Logo.png";
import copLogo from "../../assets/logos/COP_logo.PNG";
import "./Home.sass";

const isMobile = browserUtils.isMobileDevice();

const Home = ({ contentData }) => {
  return (
    <div className="home-container">
      <Helmet>
        <title>{contentData.title} | Gulf TREE</title>
      </Helmet>
      <section className="home-hero">
        <div className="home-hero-content">
          <h1>Gulf TREE</h1>
          <p>(Tools for Resilience Exploration Engine)</p>
          <h4 className="home-hero-description">
            a decision-support search engine designed to help you confidently
            identify the best climate tool for your needs.
          </h4>
          <div className="home-hero-btns">
            {isMobile && (
              <Link to={routeNames.about} className="btn-orange">
                learn more
              </Link>
            )}
            <Link to={routeNames.filteredSearch} className="btn-transparent">
              filtered search
            </Link>
            {!isMobile && (
              <Link to={routeNames.guidedSearch} className="btn-orange">
                guide my search
              </Link>
            )}
          </div>
        </div>
      </section>
      <section className="home-info-container">
        <div className="home-info">
          <section
            className="home-info-content cms__content markdown-bullet-list"
            dangerouslySetInnerHTML={{ __html: contentData.content }}
          />
          <hr />
          <div className="home-info-connect">
            <div className="home-info-section">
              <h5 className="home-info-header">Brought to you by</h5>
              <div>
                <a
                  href="https://gulfofamericaalliance.org/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="home-partner-logo"
                    src={goaaLogo}
                    alt="Gulf of America Alliance logo"
                  />
                </a>

                <a
                  href="https://msucoastal.com/place-home/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="home-partner-logo"
                    src={placeLogo}
                    alt="Program for Local Adaptation to Changing Environments (PLACE) logo"
                  />
                </a>

                <a
                  href="https://masgc.org/resilience-community-of-practice"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="home-partner-logo"
                    src={copLogo}
                    alt="Gulf Resilience Community of Practice logo"
                  />
                </a>
              </div>
            </div>
            <div className="home-info-section">
              <h5 className="home-info-header">Sign up for the newsletter</h5>
              <div className="newsletter-signup">
                {/* Mailchimp form */}
                <div id="mc_embed_signup">
                  <form
                    action="//noaa.us11.list-manage.com/subscribe/post?u=6743f9be2f62984ce99f892db&amp;id=8a4a8f49d5"
                    method="post"
                    id="mc-embedded-subscribe-form"
                    name="mc-embedded-subscribe-form"
                    target="_blank"
                    noValidate
                  >
                    <div id="mc_embed_signup_scroll">
                      <input
                        type="email"
                        name="EMAIL"
                        id="mce-EMAIL"
                        placeholder="Your e-mail"
                      />
                      {/* real people should not fill this in and expect good things - do not remove this or risk form bot signups */}
                      <div
                        style={{ position: "absolute", left: "-5000px" }}
                        aria-hidden="true"
                      >
                        <input
                          type="text"
                          name="b_6743f9be2f62984ce99f892db_8a4a8f49d5"
                          tabIndex="-1"
                          value=""
                        />
                      </div>
                      <input
                        value="SEND"
                        className="btn-blue-transparent-sm"
                        type="submit"
                        name="subscribe"
                        id="mc-embedded-subscribe"
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

Home.propTypes = {
  contentData: PropTypes.shape({
    content: PropTypes.string.isRequired,
    title: PropTypes.string,
  }),
};

export default Home;
